import type { FC, SyntheticEvent } from "react";
import { gtm } from "src/libs/gtm";

interface VideoPlayerProps {
  src: string;
  videoId: string;
  title?: string;
  poster?: string;
  borderRadius?: string;
}

// Drop-in replacement for the old Vimeo iframe embeds. The GTM event names
// (vimeo_play etc.) and videoId values are kept from the Vimeo era so
// existing GTM container triggers and backend reporting stay intact.
export const VideoPlayer: FC<VideoPlayerProps> = (props) => {
  const { src, videoId, title, poster, borderRadius } = props;

  const trackProgress = (event: string, video: HTMLVideoElement) => {
    if (video.duration > 0) {
      gtm.pushWithBackend({
        event,
        videoId,
        vimeoViewedPercentage: (video.currentTime / video.duration) * 100,
      });
    } else {
      gtm.pushWithBackend({ event, videoId, vimeoTime: video.currentTime });
    }
  };

  return (
    <video
      src={src}
      title={title}
      poster={poster}
      controls
      playsInline
      preload="metadata"
      onPlay={() => gtm.pushWithBackend({ event: "vimeo_play", videoId })}
      onPause={(e: SyntheticEvent<HTMLVideoElement>) => {
        // The browser fires pause right before ended; only report real pauses
        if (!e.currentTarget.ended) {
          trackProgress("vimeo_pause", e.currentTarget);
        }
      }}
      onEnded={(e: SyntheticEvent<HTMLVideoElement>) =>
        trackProgress("vimeo_end", e.currentTarget)
      }
      style={{
        width: "100%",
        aspectRatio: "16 / 9",
        display: "block",
        backgroundColor: "#000",
        borderRadius,
      }}
    />
  );
};
